"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-vito-al-tagliamento": {
    "04a1dd31": [{
      "hkey": "c5d21396",
      "slug": "ligugnana-braida",
      "name": "Ligugnana-Braida",
      "primary": true,
      "skipSearch": false
    }],
    "braida-bottari": [{
      "hkey": "c5d21396",
      "slug": "ligugnana-braida",
      "name": "Ligugnana-Braida",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-vito-al-tagliamento"
    }],
    "40cfb66d": [{
      "hkey": "64fa453f",
      "slug": "casabianca-ponterosso",
      "name": "Casabianca-Ponterosso",
      "primary": true,
      "skipSearch": false
    }],
    "casabianca": [{
      "hkey": "64fa453f",
      "slug": "casabianca-ponterosso",
      "name": "Casabianca-Ponterosso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f9d1dbaa": [{
      "hkey": "c5d21396",
      "slug": "ligugnana-braida",
      "name": "Ligugnana-Braida",
      "primary": true,
      "skipSearch": false
    }],
    "ligugnana": [{
      "hkey": "c5d21396",
      "slug": "ligugnana-braida",
      "name": "Ligugnana-Braida",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;